import React, {useState} from 'react';
import {
    Box,
    Card,
    Container,
    Tab,
    Tabs,
    Typography
} from "@mui/material";
import {
    AccountBalanceWalletRounded,
    PersonOutlineRounded,
    ReceiptLongRounded
} from "@mui/icons-material";
import _CorporateChargeTransactions from "./partials/_CorporateChargeTransactions";
import _UserPayTransactions from "./partials/_UserPayTransactions";

function TabPanel(props) {
    const {children, value, index, ...other} = props;
    return (
        <div role="tabpanel" hidden={value !== index} {...other}>
            {value === index && <Box sx={{ pt: 2.5 }}>{children}</Box>}
        </div>
    );
}

const Transactions = () => {
    const [tabValue, setTabValue] = useState(0);

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <Container maxWidth="xl" sx={{ pt: 3, pb: 6 }}>
            <title>تراکنش‌ها و خریدهای پرسنل | جیم‌پین سازمانی</title>

            {/* Executive Page Header */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 2,
                    mb: 3.5,
                    p: { xs: 2.5, md: 3 },
                    borderRadius: 4,
                    border: '1px solid',
                    borderColor: 'divider',
                    bgcolor: 'background.paper',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Box
                        sx={{
                            width: 54,
                            height: 54,
                            borderRadius: '16px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            bgcolor: 'primary.main',
                            color: '#fff',
                            boxShadow: '0 8px 20px rgba(45, 107, 226, 0.3)',
                        }}
                    >
                        <ReceiptLongRounded sx={{ fontSize: 32 }} />
                    </Box>
                    <Box>
                        <Typography variant="h5" sx={{ fontWeight: 800, mb: 0.5 }}>
                            تراکنش‌ها و خریدهای پرسنل
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            ریز مصرف، شارژها و پرداخت‌های اعتباری انجام‌شده توسط پرسنل سازمان
                        </Typography>
                    </Box>
                </Box>
            </Box>

            {/* Tabs Card */}
            <Card
                elevation={0}
                sx={{
                    borderRadius: 3.5,
                    border: '1px solid',
                    borderColor: 'divider',
                    bgcolor: 'background.paper',
                    overflow: 'hidden'
                }}
            >
                <Tabs
                    value={tabValue}
                    onChange={handleChange}
                    sx={{
                        px: 2,
                        minHeight: 56,
                        '& .MuiTab-root': {
                            minHeight: 56,
                            fontWeight: 800,
                            fontSize: '0.9rem',
                            gap: 1
                        }
                    }}
                >
                    <Tab
                        icon={<AccountBalanceWalletRounded fontSize="small" />}
                        iconPosition="start"
                        label="پرداخت‌های اعتباری سازمان"
                    />
                    <Tab
                        icon={<PersonOutlineRounded fontSize="small" />}
                        iconPosition="start"
                        label="پرداخت‌های شخصی پرسنل"
                    />
                </Tabs>
            </Card>

            <TabPanel value={tabValue} index={0}>
                <_CorporateChargeTransactions />
            </TabPanel>

            <TabPanel value={tabValue} index={1}>
                <_UserPayTransactions />
            </TabPanel>
        </Container>
    );
};

export default Transactions;
